import { baseApi } from './baseApi';
import { BioLibSingleton } from '@biolibtech/biolib-js/src';
import AuthCookie from '../features/userFlow/utils/AuthCookie';
import userConstants from '../state/user/userConstants';
import { IAuthStatus } from './authApi.types';

interface IOAuthTokenExchangeRequest {
    scope: string;
    job_uuid: string;
}

interface IOAuthTokenExchangeResponse {
    access_token: string;
}

export const authApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        getAuthStatus: build.query<IAuthStatus, { eager?: boolean }>({
            query: (args) => ({
                url: `/auth/status/?include_authorization_url=true${
                    args.eager ? '&eager_re_authentication=true' : ''
                }`,
            }),
        }),
        logout: build.mutation<null, void>({
            queryFn: async (args, { dispatch }, extraOptions, baseQuery) => {
                // Clear tokens and fire logout request without awaiting
                AuthCookie.clear();
                BioLibSingleton.get().user.clearTokens();
                dispatch(baseApi.util.resetApiState());
                dispatch({ type: userConstants.SIGN_OUT }); // Clear legacy redux state
                // Purposely not awaited to avoid blocking navigation
                baseQuery({ url: '/auth/logout/', method: 'POST' });
                window.location.assign(location.origin); // Redirect to front page
                return { data: null };
            },
        }),
        oauthTokenExchange: build.mutation<IOAuthTokenExchangeResponse, IOAuthTokenExchangeRequest>({
            query: ({ scope, job_uuid }) => ({
                url: '/auth/oauth-token-exchange/',
                method: 'POST',
                body: { scope, job_uuid },
            }),
        }),
    }),
});

export const { useGetAuthStatusQuery, useLogoutMutation, useOauthTokenExchangeMutation } = authApi;
